import { styled } from '@mui/material';
import { ReactComponent as IBMCloud } from '../../../assets/images/ibmCloud.svg';

export const StyledIconIBMCloud = styled(IBMCloud)(() => ({
  height: '46px',
  width: '46px',
}));
